import { render, staticRenderFns } from "./LeadDetailsForm.vue?vue&type=template&id=4ee52cbb&scoped=true&"
import script from "./LeadDetailsForm.vue?vue&type=script&lang=js&"
export * from "./LeadDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee52cbb",
  null
  
)

export default component.exports